module.exports = __webpack_public_path__ + "static/media/media_tv.75918917.png";